import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ContactApiService } from '../../data-services/index';

import { IApplicationPayment, IContact } from '@ebb-v2/ebb-integration';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';

export interface IDataPaymentAuthorizationForm {
  applicationPayment: IApplicationPayment;
  applicationOwner: IContact;
  applicationContractor: IContact;
  pafCompany: string;
  pafFullName: string;
  pafTypeCode: number;
  pafAddressStreet: string;
  pafAddressCity: string;
  pafAddressState: string;
  pafAddressZip: string;
  pafAuthorizationDate: Date;
}

@Component({
  selector: 'ebb-portal-dialog-paform',
  templateUrl: './dialog-paform.component.html'
})
export class DialogPaformComponent implements OnInit {
  public formPayeeInfo: FormGroup;
  public isDoItYourself = false;
  public currentPayee: number = null;
  public payeeIsHomeowner = false;
  public payeeIsContractor = false;
  public currentDate: Date = new Date();

  constructor(
    public readonly dialogRef: MatDialogRef<DialogPaformComponent>,
    private readonly fb: FormBuilder,
    private readonly apiContact: ContactApiService,
    @Inject(MAT_DIALOG_DATA) public data: IDataPaymentAuthorizationForm
  ) { }

  ngOnInit() {
    this.initializeForms();
    this.loadContactData();
  }

  private initializeForms(): void {
    // Owner: 700000000; Contractor: 700000001
    this.formPayeeInfo = this.fb.group({
      payeeTypeCode: ''
    });
  }

  private loadContactData(): void {
    if (this.data.applicationOwner.id === this.data.applicationContractor.id) {
      this.isDoItYourself = true;
      this.currentPayee = 700000000;
      this.data.pafTypeCode = 700000000;
      this.data.pafCompany = '';
      this.data.pafFullName = this.data.applicationOwner.fullName;
      this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
      this.data.pafAddressCity = this.data.applicationOwner.address1_City;
      this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
    } else {
      if (this.data.applicationPayment) {
        if (this.data.applicationPayment.pafTypeCode === 700000000) {
          this.currentPayee = 700000000;
          this.payeeIsHomeowner = true;
          this.data.pafTypeCode = 700000000;
          this.data.pafCompany = '';
          this.data.pafFullName = this.data.applicationOwner.fullName;
          this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
          this.data.pafAddressCity = this.data.applicationOwner.address1_City;
          this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
          this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
        }
        if (this.data.applicationPayment.pafTypeCode === 700000001) {
          this.currentPayee = 700000001;
          this.payeeIsContractor = true;
          this.data.pafTypeCode = 700000001;
          this.data.pafCompany = this.data.applicationContractor.businessName;
          this.data.pafFullName = this.data.applicationContractor.fullName;
          (this.data.applicationContractor.address3_Line2 && this.data.applicationContractor.address3_Line2.length > 0)
            ? this.data.pafAddressStreet = `${this.data.applicationContractor.address3_Line1}, ${this.data.applicationContractor.address3_Line2}`
            : this.data.pafAddressStreet = this.data.applicationContractor.address3_Line1;
          this.data.pafAddressCity = this.data.applicationContractor.address3_City;
          this.data.pafAddressState = this.data.applicationContractor.address3_StateOrProvince;
          this.data.pafAddressZip = this.data.applicationContractor.address3_PostalCode;
        }
      }
    }
  }

  public onChangeEventPayee(event: MatRadioChange): void {
    if (parseInt(event.value.toString(), 10) === 700000000) {
      this.currentPayee = 700000000;
      this.data.pafTypeCode = 700000000;
      this.data.pafCompany = '';
      this.data.pafFullName = this.data.applicationOwner.fullName;
      this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
      this.data.pafAddressCity = this.data.applicationOwner.address1_City;
      this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
    } else {
      this.currentPayee = 700000001;
      this.data.pafTypeCode = 700000001;
      this.data.pafCompany = this.data.applicationContractor.businessName;
      this.data.pafFullName = this.data.applicationContractor.fullName;
      (this.data.applicationContractor.address3_Line2 && this.data.applicationContractor.address3_Line2.length > 0)
      ? this.data.pafAddressStreet = `${this.data.applicationContractor.address3_Line1}, ${this.data.applicationContractor.address3_Line2}`
      : this.data.pafAddressStreet = this.data.applicationContractor.address3_Line1;
      this.data.pafAddressCity = this.data.applicationContractor.address3_City;
      this.data.pafAddressState = this.data.applicationContractor.address3_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationContractor.address3_PostalCode;
    }
  }

  public onClickSave(): void {
    this.data.pafTypeCode = this.currentPayee;
    this.data.pafAuthorizationDate = this.currentDate;
    if (this.data.pafTypeCode === 700000001 &&
        (this.data.pafCompany && this.data.pafCompany.length > 0)) {
      this.data.pafFullName = this.data.pafCompany;
    }
    this.dialogRef.close(this.data);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

}
